export const sleep = async (ms: number) => new Promise(r => setTimeout(r, ms));